import { useId } from "react";
import { t } from "../../i18n/strings";
import type { CrisisResource } from "../../engine/types";
import type { Locale } from "../../templates/types";

/**
 * §11: defaults are US-only (988, the DV hotline) and the copy says so
 * plainly — a real deployment must substitute community-approved local
 * resources. Fieldnote must never present itself as a crisis service.
 */
export function CrisisResources({ resources, locale = "en" }: { resources: CrisisResource[]; locale?: Locale }) {
  const headingId = useId();

  if (resources.length === 0) return null;

  // A named landmark region: this content is safety-critical, and a screen
  // reader user should be able to locate it directly rather than stumble on
  // it while reading linearly through the paused chat.
  return (
    <div role="region" aria-labelledby={headingId} className="rounded-lg border border-danger/30 bg-danger-dim p-3">
      <p id={headingId} className="text-xs text-ink-soft">
        {t(locale, "safety.crisisResources.framing")}
      </p>
      <ul className="mt-2 space-y-1">
        {resources.map((r) => (
          <li key={r.label} className="text-sm text-ink">
            <span className="font-medium">{r.label}</span>
            {r.phone && <span> — {r.phone}</span>}
            {r.url && (
              <>
                {" "}
                — <a href={r.url} className="underline">{r.url}</a>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
